<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'ADMIN.TRAVEL_REQUESTS.TEMPLATES.TITLE' | translate }}</h2>
  <button
    mat-icon-button
    type="button"
    class="close-icon-button"
    [attr.aria-label]="'SHARED.DIALOGS.IMAGE_DIALOG.CLOSE' | translate"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="templates-content">
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @for (row of rows(); track row.type) {
    <div class="template-section">
      <span class="section-label">{{ row.sectionLabelKey | translate }}</span>

      @if (row.uploading) {
        <div class="dropzone-loading">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      } @else {
        <app-file-drop-zone
          [accept]="docxAccept"
          [hint]="row.dropHintKey | translate"
          (filesAdded)="onFilesAdded(row.type, $event)"
        ></app-file-drop-zone>
      }

      @if (row.status && row.status.exists) {
        <div class="file-card">
          <div class="file-main">
            <mat-icon aria-hidden="true">insert_drive_file</mat-icon>
            <div class="file-info">
              <span class="file-name">{{ row.status.originalFileName }}</span>
              <span class="file-date">
                {{ 'ADMIN.TRAVEL_REQUESTS.TEMPLATES.UPLOADED' | translate }}
                {{ row.status.uploadedOn | date: 'dd.MM.yyyy' }}
              </span>
            </div>
          </div>

          <div class="file-actions">
            <button
              mat-icon-button
              type="button"
              class="download-icon-button"
              [attr.aria-label]="'ADMIN.TRAVEL_REQUESTS.TEMPLATES.DOWNLOAD' | translate"
              [matTooltip]="'ADMIN.TRAVEL_REQUESTS.TEMPLATES.DOWNLOAD' | translate"
              [disabled]="row.downloading"
              (click)="downloadTemplate(row)"
            >
              @if (row.downloading) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <mat-icon>download</mat-icon>
              }
            </button>

            <button
              mat-icon-button
              type="button"
              class="delete-icon-button"
              [attr.aria-label]="'ADMIN.TRAVEL_REQUESTS.TEMPLATES.DELETE' | translate"
              [matTooltip]="'ADMIN.TRAVEL_REQUESTS.TEMPLATES.DELETE' | translate"
              [disabled]="row.deleting"
              (click)="deleteTemplate(row)"
            >
              @if (row.deleting) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <mat-icon>close</mat-icon>
              }
            </button>
          </div>
        </div>
      }
    </div>
  }
</mat-dialog-content>
